import React from "react";
//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
//Material-ui
import Fab from '@material-ui/core/Fab';
import Grid from '@material-ui/core/Grid';
//Icon

import { FaEnvelope } from 'react-icons/fa';
//Image
import sampleImgMen from '../img/user/sampleImg_men.png';
import sampleImgWomen from '../img/user/sampleImg_women.png';

class Comp extends React.Component {

  componentDidMount() {
    window.gtag("event", 'new_profile_end');
  }

  render() {
    return (
      <div style={{maxWidth:'400px', margin:'auto'}}>
        <div style={{padding:'10px'}}>
          <h1 align='center'>
            <span className='i-b'>パートナーズにようこそ</span>
          </h1>
          <Grid container justifyContent="center" alignItems="center" spacing={1} style={{padding:'10px'}}>
            <Grid item>
              <img
                src={ sampleImgMen }
                style={{height:'80px',width:'auto',borderRadius:'40px'}}
                alt=''
              />
            </Grid>
            <Grid item>
              <FaEnvelope style={{fontSize:'3em', color:'#CCC'}} />
            </Grid>
            <Grid item>
              <img
                src={ sampleImgWomen }
                style={{height:'80px',width:'auto',borderRadius:'40px'}}
                alt=''
              />
            </Grid>
          </Grid>
          <h4 align='center' style={{padding:'10px'}}>
            <span className='i-b'>利用方法はとてもシンプル、</span>
            <span className='i-b'>やり取りを始めるのに</span>
            <span className='i-b'>「いいね」は必要ありません</span>
            <span className='i-b'>気軽にご挨拶からメールができます。</span>
          </h4>
        </div>

        <div style={{padding:'10px'}}>
          {
            (this.props.my.profile.userdata_sex === 'men') ? (
              <>
                <h1 align='center'>無料メールでアプローチ</h1>
                <h4 align='center' style={{padding:'10px'}}>
                  <span className='i-b'>証明書を提出いただくと</span>
                  <span className='i-b'>無料メールが送信できます。</span>
                	<span className='i-b'>アプローチまで無料で使える</span>
                  <span className='i-b'>安心システムです。</span>
                </h4>
              </>
            ): (
              <>
                <h1 align='center'>女性完全無料</h1>
                <h4 align='center' style={{padding:'10px'}}>
                  <span className='i-b'>すべて完全無料でご利用いただけます。</span>
                  <span className='i-b'>登録から交際・ご成婚まで</span>
                	<span className='i-b'>一切料金は発生いたしません。</span>
                </h4>
              </>
            )
          }


          <div align='center' style={{padding:'10px'}}>
            <Fab
              variant="extended"
              color="primary"
              onClick={ () => this.props.history.push('/') }
              style={{fontSize:'1.2em'}}
            >
              ホームに移動する
            </Fab>
          </div>



        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
	return {
		auth: state.auth,
    my: state.my,
	}
};
const mapDispatchToProps = dispatch => (
	bindActionCreators({
    ...myProfileAction,
	}, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
